import { render } from "./EditMessageWindow.vue?vue&type=template&id=762b9dd2&scoped=true"
import script from "./EditMessageWindow.vue?vue&type=script&lang=js"
export * from "./EditMessageWindow.vue?vue&type=script&lang=js"

import "./EditMessageWindow.vue?vue&type=style&index=0&id=762b9dd2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762b9dd2"]])

export default __exports__